import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import CurrencyFormat from "../shared/CurrencyFormat";
import Rating from "../Rating";

const Products = ({ title, products }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);

  const handleNext = () => {
    if (!isTransitioning) {
      setIsTransitioning(true);
      setCurrentIndex((prev) => (prev === products.length - 1 ? 0 : prev + 1));
      setTimeout(() => setIsTransitioning(false), 500);
    }
  };

  useEffect(() => {
    const handleNext = () => {
      if (!isTransitioning) {
        setIsTransitioning(true);
        setCurrentIndex((prev) =>
          prev === products.length - 1 ? 0 : prev + 1
        );
        setTimeout(() => setIsTransitioning(false), 500);
      }
    };

    const timer = setInterval(() => {
      handleNext();
    }, 5000); // Change slide every 5 seconds

    return () => clearInterval(timer);
  }, [currentIndex, isTransitioning, products.length]);

  const handlePrevious = () => {
    if (!isTransitioning) {
      setIsTransitioning(true);
      setCurrentIndex((prev) => (prev === 0 ? products.length - 1 : prev - 1));
      setTimeout(() => setIsTransitioning(false), 500);
    }
  };

  return (
    <div className="flex flex-col gap-6">
      <div className="flex justify-between items-center px-4 py-2">
        <div className="text-xl font-bold text-slate-600">{title}</div>
        {products.length > 3 && (
          <div className="flex gap-3">
            <button
              onClick={handlePrevious}
              className="w-8 h-8 flex justify-center items-center bg-slate-300 border border-slate-200 rounded-lg hover:bg-slate-400 transition"
            >
              <IoIosArrowBack />
            </button>
            <button
              onClick={handleNext}
              className="w-8 h-8 flex justify-center items-center bg-slate-300 border border-slate-200 rounded-lg hover:bg-slate-400 transition"
            >
              <IoIosArrowForward />
            </button>
          </div>
        )}
      </div>

      <div className="relative overflow-hidden">
        <div
          className="flex transition-transform duration-500 ease-in-out"
          style={{
            transform: `translateX(-${currentIndex * 100}%)`,
          }}
        >
          {products.map((p, i) => (
            <div
              key={i}
              className="w-full flex-shrink-0 flex flex-col gap-4 px-4 py-2 bg-white rounded-md"
            >
              {p.map((pl, j) => (
                <Link
                  key={j}
                  className="flex gap-3 items-center hover:bg-slate-100 p-2 rounded-md transition relative"
                  to={`/product/details/${pl.slug}`}
                >
                  {pl.discount && (
                    <div className="flex justify-center items-center absolute text-white w-10 h-10 rounded-full bg-green-600 font-semibold text-xs left-2 top-2">
                      {pl.discount}%
                    </div>
                  )}
                  <img
                    className="w-24 h-24 object-cover rounded-md"
                    src={pl.images[0]}
                    alt={pl.name}
                  />
                  <div className="flex flex-col gap-1 text-slate-600">
                    <h2 className="font-medium text-sm truncate">{pl.name}</h2>
                    <span
                      className={
                        "text-lg font-bold " +
                        (pl.discount > 0 ? "text-green-600" : "")
                      }
                    >
                      <CurrencyFormat
                        value={pl.price - (pl.price * pl.discount) / 100}
                      />
                    </span>
                    <div className="flex">
                      <Rating ratings={pl.rating} />
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Products;
